import React from 'react';
import { useEffect, useState } from 'react';
import { Form, Modal, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import HesSpinner from '../../../../../../../../components/loadingOverlay/hesSpinner';
import './teacherCommentModal.scss';

function TeacherCommentModal(props) {
  const [isSaving, setIsSaving] = useState(false);
  const [teacherComment, setTeacherComment] = useState('');

  useEffect(() => {
    if (props.studentAnswerDetails) {
      props.setError('');
      setTeacherComment(props.studentAnswerDetails.crAnswer?.teacherComment);
    }
  }, [props.studentAnswerDetails]);

  async function handleSaveComment() {
    props.setError('');
    setIsSaving(true);
    try {
      await props.handleCommentChange(teacherComment);
      setIsSaving(false);
    } catch (ex) {
      console.log(ex);
      props.setError('An error has occured while trying to save feedback');
      setIsSaving(false);
    }
  }

  return (
    <Modal
      show={props.show}
      onHide={props.onHide}
      size='lg'
      centered
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title id='feedbackModal'>
          <h1>Add/Edit Feedback</h1>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className='d-flex flex-column'>
          <Form.Group className='mb-3'>
            <div className='d-flex justify-content-between'>
              <Form.Label>Feedback</Form.Label>
              {teacherComment?.length > 0 &&
              <Form.Label>{`${teacherComment.length}/2500`}</Form.Label>
              }
            </div>
            <Form.Control as='textarea' rows={10} style={{ width: '35vw', maxWidth: '690px', minWidth: '300px', height: '150px' }} id="teacherComment" value={teacherComment} onChange={(e)=>setTeacherComment(e.target.value)}/>
          </Form.Group>

          {props.error && <div style={{ color: '#F84646', fontSize: '11px', textAlign: 'center'} }>{props.error}</div>}

          <div className='d-flex flex-row justify-content-end'>
            <Button onClick={props.onHide} className='me-2' variant='castleGray'>Cancel</Button>
            <Button onClick={() => handleSaveComment()} className="d-flex flex-row justify-content-center position-relative" disabled={isSaving} variant='castleRed'>
              <div className="saveButtonContainer">
                {isSaving && <div style={{ height: '70%', marginRight: '1rem' }}><HesSpinner /></div>}
                <div>{isSaving ? 'Saving...' : 'Save'}</div>
              </div>

            </Button>
          </div>

        </div>
      </Modal.Body>
    </Modal>
  );
}

TeacherCommentModal.propTypes = {
  studentAnswerDetails: PropTypes.any.isRequired,
  show: PropTypes.func,
  onHide: PropTypes.any,
  handleCommentChange: PropTypes.func,
  setError: PropTypes.func,
  error: PropTypes.string

};


export default TeacherCommentModal;